import { Actions } from 'vuex-smart-module';
import { Filters, FiltersPagination } from '@/types';
import { ResponseStatuses } from '@/enums';
import { AxiosResponse } from 'axios';
import { Projects } from '@/modules/projects/types';
import ProjectsState from './state';
import ProjectsMutations from './mutaitons';
import ProjectsGetters from './getters';
import { ProjectsService } from '../services';

const projectsService = new ProjectsService();

export default class ProjectsActions extends Actions<
  ProjectsState,
  ProjectsGetters,
  ProjectsMutations,
  // eslint-disable-next-line no-use-before-define
  ProjectsActions
> {
  async get_projects() {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }
      this.mutations.TOGGLE_LOADING_PROJECTS(true);
      const { data, meta } = await projectsService.get_projects(payload);

      this.mutations.SET_PROJECTS(data.items);
      this.mutations.SET_PARNER_CONTACT_PERSONS(data.partner_contact_persons);
      this.mutations.SET_ORGANIZATIONS(data.organizations);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_LOADING_PROJECTS(false);
    }
  }

  async get_project_by_id(id: string | number) {
    try {
      const { data, code = ResponseStatuses.Fail.FORBIDDEN } = await projectsService.get_project_by_id(id);

      this.mutations.SET_CURRENT_PROJECT(data);
      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }

  async add_new_project() {
    try {
      const {
        new_project, products, equipments, competitors,
      } = this.state;

      const payload = {
        ...new_project,
        products: [...products],
        equipments: [...equipments],
        competitors: [...competitors],
      };
      const code = await projectsService.add_new_project(payload);

      return code;
    } catch (error) {
      console.log(error);
    }
  }

  async get_catalog_products(filtersEmpty: boolean) {
    this.mutations.SET_CATALOG_PRODUCTS_LOADING(true);

    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.catalog_products_table_options;

      const payload: Projects.CatalogProductRequest = {
        filters: this.state.catalog_products_filters,
        filters_exist: !filtersEmpty,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      const { data, meta } = await projectsService.get_catalog_products(payload);

      this.mutations.SET_CATALOG_PRODUCTS(data.items);

      this.mutations.UPD_CATALOG_PRODUCTS_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_CATALOG_PRODUCTS_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_CATALOG_PRODUCTS_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_CATALOG_PRODUCTS_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_CATALOG_PRODUCTS_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_CATALOG_PRODUCTS_PAGINATION_FIELD({ key: 'limit', value: meta.limit });

      return data.filters;
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.SET_CATALOG_PRODUCTS_LOADING(false);
    }
  }
}
